
// export const API_BASE_URL = 'http://localhost/sailedger/public';
export const API_BASE_URL = 'https://ledger.saibranding.com/backend/public';

// function checkAuthentication() {
//   const authToken = localStorage.getItem('authToken'); // Retrieve from localStorage
//   const userId = localStorage.getItem('userId'); // Retrieve userId

//   if (!authToken || !userId) {
//     Swal.fire("Error", "Authentication required. Please log in.", "error");
//     window.location.href = "/"; // Redirect to the login page
//     return;
//   }
// }

// // Example usage
// checkAuthentication();
